import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function FAQPage() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: t('faq.q1'),
      answer: t('faq.a1')
    },
    {
      question: t('faq.q2'),
      answer: t('faq.a2')
    },
    {
      question: t('faq.q3'),
      answer: t('faq.a3')
    },
    {
      question: t('faq.q4'),
      answer: t('faq.a4')
    },
    {
      question: t('faq.q5'),
      answer: t('faq.a5')
    },
    {
      question: t('faq.q6'),
      answer: t('faq.a6')
    },
    {
      question: t('faq.q7'),
      answer: t('faq.a7')
    },
    {
      question: t('faq.q8'),
      answer: t('faq.a8')
    }
  ];

  return (
    <div className="min-h-screen pt-28 pb-20 bg-brand-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <span className="font-accent text-brand-gold text-sm tracking-[0.3em] uppercase">{t('footer.help')}</span>
          <h1 className="font-heading text-4xl lg:text-5xl font-bold text-brand-black mt-2">{t('faq.title')}</h1>
          <p className="text-brand-dark/60 mt-4">{t('faq.subtitle')}</p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05 }}
              className="border border-brand-gold/20 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left bg-brand-cream hover:bg-brand-cream transition-colors"
              >
                <div className="flex items-center gap-3">
                  <HelpCircle className="h-5 w-5 text-brand-gold flex-shrink-0" />
                  <span className="text-brand-black font-medium">{faq.question}</span>
                </div>
                <ChevronDown className={`h-5 w-5 text-brand-dark/50 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} />
              </button>
              {openIndex === index && (
                <div className="p-5 bg-brand-white border-t border-brand-gold/10">
                  <p className="text-brand-dark/80 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </motion.div>
          ))}
        </div>

        <div className="mt-12 text-center p-8 bg-brand-cream rounded-lg">
          <p className="text-brand-dark/80">{t('faq.notFound')}</p>
          <Link to="/contact" className="text-brand-gold font-medium hover:underline">{t('faq.contactUs')} →</Link>
        </div>
      </div>
    </div>
  );
}
